import { Form, Input, InputNumber, Select, Switch, Checkbox, Radio, Card } from 'antd';
import { fetch } from '@/common/request';
import { useEffect, useState } from 'react';
import { NODE_TYPE } from '../../constants';
import atoms from '@/styles/atoms.module.scss';

/** 变量项定义 */
export interface Variable {
  /** 变量唯一标识 */
  id: number;

  /** 所属节点类型 ID */
  nodeTypeId: NODE_TYPE;

  /** 变量名称（程序内部使用） */
  variableName: string;

  /** 变量显示名称（可为空） */
  variableLabel?: string | null;

  /** 变量类型（string、number、boolean、array、object 等） */
  variableType: 'string' | 'number' | 'boolean' | 'array' | 'object' | string;

  /** 是否必填 */
  required: boolean;

  /** 变量描述，用于提示说明 */
  description?: string | null;

  /** 默认值 */
  defaultValue?: any;

  /** 变量结构定义（当 variableType = object 时可能有值） */
  schema?: Record<string, any> | null;

  /** 是否仅展示（不可编辑） */
  displayOnly: boolean;

  /** 变量分类类型（业务自定义，例如 1 输入；2 输出 */
  type: 1 | 2;

  /** 排序字段 */
  sort: number;

  /** 控件展示类型（input、select、textarea、switch 等） */
  displayType: string;
}

interface Option {
  label: string;
  value: string | number;
}

const VariableRender = (variable: Variable) => (
  <div className="flex h-8 cursor-pointer items-center justify-between rounded-lg border  border-components-panel-border-subtle bg-components-panel-on-panel-item-bg px-2.5 shadow-xs hover:shadow-md">
    <div className={`flex w-0 grow items-center space-x-1 text-[13px] font-medium ${atoms.textSecondary}`}>
      <span>{variable.variableName}</span>
      <span>{variable.description}</span>
    </div>
    <div className="ml-2 flex shrink-0 items-center text-xs font-normal">
      {variable?.required && '必填'}
      {variable.variableType}
    </div>
  </div>
);

const getVariableComponent = (variable: Variable): React.ReactNode => {
  const {
    displayType,
    nodeTypeId,
    variableName,
    variableType,
    required,
    description,
    defaultValue,
    schema,
    displayOnly,
  } = variable;
  const [options, setOptions] = useState<Option[]>([]);

  const params = {
    disabled: displayOnly,
  };

  if (nodeTypeId === NODE_TYPE.START) {
    return VariableRender(variable);
  }

  switch (displayType) {
    default:
      return (
        <>
          <div className="flex items-center leading-[18px]">
            <span className={`code-sm-semibold ${atoms.textSecondary}`}>{variableName}</span>
            <span className={`system-xs-regular ml-2 ${atoms.textMuted}`}>{variableType}</span>
          </div>
          <div className={`system-xs-regular mt-0.5 ${atoms.textMuted}`}>{description}</div>
        </>
      );
  }
};

export default getVariableComponent;
